import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { isEmpty } from "lodash"
import CardList from "components/common/CardList"
import Pagination from "react-js-pagination"
import PageContainer from "components/common/PageContainer"
import HeroHeader from "components/hero-header/index"
import { BUNDLE_SORT_PARAMS } from "constants/sort-values"
import { checkParams } from "helpers/util"
import "styles/pages/bundles.scss"
import {
  fetchAllBundles,
  fetchCategories,
  fetchSubcategories,
} from "store/courses/action"
import BlankSlate from "../../components/blank-slate"

class CourseBundlesPage extends Component {
  constructor() {
    super()

    this.state = {
      searchParam: "",
      activePage: 1,
      sortParam: "-created_at",
      subcategory: 0,
      typing: false,
      typingTimeout: 0,
    }
  }

  componentDidMount() {
    const {
      school: { schoolData },
    } = this.props

    if (!isEmpty(schoolData)) {
      this.fetchBundleData()
      this.fetchCategories()
      this.fetchSubcategories()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      school: { schoolData: prevSchoolData = {} },
    } = prevProps

    const {
      school: { schoolData = {} },
    } = this.props

    if (schoolData.id && prevSchoolData.id !== schoolData.id) {
      this.fetchBundleData()
      this.fetchCategories()
      this.fetchSubcategories()
    }
  }

  fetchBundleData = () => {
    const {
      school: { schoolData },
      auth: { isAuthorized },
      fetchAllBundles,
    } = this.props
    const { sortParam, searchParam, category, subcategory, activePage } =
      this.state

    let data = {
      pageNumber: `page=${activePage}`,
      rowsPerPage: `perpage=6`,
      sortParam: sortParam ? `sort=${sortParam}` : "",
      searchParam: searchParam ? `bundle_name=${searchParam}` : "",
      categoryParam: category ? `category=${category}` : "",
      subcategoryParam: subcategory ? `subcategory=${subcategory}` : "",
    }

    fetchAllBundles(checkParams(data), schoolData.id, isAuthorized)
  }

  fetchCategories = () => {
    const {
      school: { schoolData },
      fetchCategories,
    } = this.props

    fetchCategories(schoolData.id)
  }

  fetchSubcategories = () => {
    const {
      school: { schoolData },
      fetchSubcategories,
    } = this.props

    fetchSubcategories(schoolData.id)
  }

  handleChange = (e) => {
    const { name, value } = e.currentTarget

    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout)
    }

    this.setState({
      [name]: value,
      activePage: 1,
      typing: false,
      typingTimeout: setTimeout(() => {
        this.fetchBundleData()
      }, 500),
    })
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, () => this.fetchBundleData())
  }

  handleSort = (event) => {
    const { name, value } = event.currentTarget
    this.setState({ [name]: value, activePage: 1 }, () =>
      this.fetchBundleData()
    )
  }

  handleChangeCategory = (e) => {
    const { value } = e?.currentTarget

    this.setState({ category: value, activePage: 1 }, () =>
      this.fetchBundleData()
    )
  }

  handleSelectSubcategory = (value) => {
    const { subcategory } = this.state

    if (value === subcategory) {
      this.setState({ subcategory: 0, activePage: 1 }, () =>
        this.fetchBundleData()
      )
    } else {
      this.setState({ subcategory: value, activePage: 1 }, () =>
        this.fetchBundleData()
      )
    }
  }

  render() {
    const { searchParam, activePage, sortParam, subcategory } = this.state
    const {
      courses: { bundleData, isLoadingBundles, subcategories = [] },
      school: { schoolData },
    } = this.props

    var routeList = {
      "/": "Home",
      "/course-bundles": "Course Bundles",
    }

    return (
      <PageContainer>
        <HeroHeader
          title="Course Bundles"
          description="Collection of courses bundled just for you."
          routeList={routeList}
          onChange={this.handleChange}
          searchValue={searchParam}
          searchEnabled
          activeColor={schoolData.primary_color}
          activeItem="Course Bundles"
        />
        <div className="img-banner" />
        <div className="courses-page">
          <div className="course-options">
            {/* <div className="dropdown">
              <p className="label">Category</p>
              <div className="select-wrapper" id="sort">
                <select
                  className="select"
                  onChange={this.handleChangeCategory}
                  value={category}
                  name="sortParam"
                >
                  {categories &&
                    categories.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.text}
                      </option>
                    ))}
                </select>
              </div>
            </div> */}
            <div className="dropdown">
              <p className="label">Sort</p>
              <div className="select-wrapper" id="sort">
                <select
                  className="select"
                  onChange={this.handleSort}
                  value={sortParam}
                  name="sortParam"
                >
                  {BUNDLE_SORT_PARAMS &&
                    BUNDLE_SORT_PARAMS.map((item) => (
                      <option value={item.value} key={item.id}>
                        {item.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          <div className="category-list">
            {subcategories &&
              subcategories.map((item) => (
                <button
                  key={item.id}
                  name="subcategory"
                  className={`category-items ${
                    item.id === subcategory ? "active" : ""
                  }`}
                  onClick={() => this.handleSelectSubcategory(item.id)}
                  style={
                    item.id === subcategory
                      ? { borderColor: schoolData.primary_color }
                      : {}
                  }
                >
                  {item.name}
                </button>
              ))}
          </div>
          {bundleData && bundleData.data && bundleData.data.length ? (
            <>
              <CardList
                data={bundleData.data}
                loading={isLoadingBundles}
                type="bundle"
              />
              <div className="meta-section">
                <Pagination
                  prevPageText="Prev"
                  nextPageText="Next"
                  hideFirstLastPages
                  pageRangeDisplayed={5}
                  activePage={activePage}
                  itemsCountPerPage={6}
                  totalItemsCount={bundleData.count ? bundleData.count : 0}
                  onChange={this.handlePageChange}
                  innerClass="card-pagination"
                  itemClass="pagination-item"
                  itemClassPrev="pagination-action"
                  itemClassNext="pagination-action"
                  disabledClass="action-disabled"
                  activeClass="item-active"
                />
                <p className="sort-count">
                  Showing {6 * activePage - 6 + 1} to{" "}
                  {6 * activePage > bundleData.count
                    ? bundleData.count
                    : 6 * activePage}{" "}
                  of {bundleData.count}
                </p>
              </div>
            </>
          ) : (
            <BlankSlate
              text="No course bundled yet"
              description="We can't find what you are looking for, you can try narrowing it down in your search."
            />
          )}
        </div>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  school: state.schoolReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { fetchAllBundles, fetchCategories, fetchSubcategories },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CourseBundlesPage)
